import { render, staticRenderFns } from "./ClientJbbfBaseContent.vue?vue&type=template&id=04190c06&"
import script from "./ClientJbbfBaseContent.vue?vue&type=script&lang=js&"
export * from "./ClientJbbfBaseContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports